import React from 'react'
import { Field } from 'redux-form'
import { BFormGroup, BInput, BLabel, BFormText } from '@prague-digi/ui-components'
import { fieldAdapter, FieldProps } from '../../utils/field'
import { CZECH_PHONE_PREFIX } from '../../constants'

import styles from './styles.scss'

export interface Props {
  name: string
  testid: string
  messages?: {
    label?: string
    notice?: string
    warning?: string
    error?: string
  }
}

export class PhoneInput extends React.Component<Props & FieldProps> {
  onChangeNumber = (evt: any) => this.props.onChange(this.updateNumber(evt.target.value))

  onBlurNumber = (evt: any) => this.props.onBlur(this.updateNumber(evt.target.value))

  updateNumber = (number: string): string => `${number}`.trim()

  render() {
    const { name, value, messages } = this.props
    const label = messages && messages.label
    const notice = messages && messages.notice
    const warning = messages && messages.warning
    const error = messages && messages.error

    return (
      <BFormGroup error={!!error} warning={!!warning}>
        <BLabel>{label}</BLabel>
        <div className={styles.phoneEntry}>
          <BInput disabled theme={styles.phonePrefix} value={CZECH_PHONE_PREFIX} />
          <BInput
            name={name}
            onBlur={this.onBlurNumber}
            onChange={this.onChangeNumber}
            testid={name}
            theme={styles.phoneNumber}
            value={value}
          />
        </div>
        {(notice || error || warning) && (
          <p>
            {notice && <BFormText>{notice}</BFormText>}
            {error && <BFormText>{error}</BFormText>}
            {warning && <BFormText>{warning}</BFormText>}
          </p>
        )}
      </BFormGroup>
    )
  }
}

export const renderPhoneInput = fieldAdapter(PhoneInput)
export const PhoneInputField: React.FunctionComponent<Props> = (props: Props) => (
  <Field {...props} component={renderPhoneInput} />
)
export default PhoneInputField
